/* AimGrips Contact — textarea auto-grow, submit feedback, success scroll */
(function () {
  'use strict';

  function init() {
    /* Auto-grow the message textarea as you type (satisfying feedback) */
    Array.prototype.forEach.call(document.querySelectorAll('[data-agc-grow]'), function (ta) {
      var grow = function () {
        ta.style.height = 'auto';
        ta.style.height = Math.min(ta.scrollHeight, 360) + 'px';
      };
      ta.addEventListener('input', grow);
      grow();
    });

    /* "Sending…" state on submit (the contact form is a full-page POST) */
    Array.prototype.forEach.call(document.querySelectorAll('form.agc-form'), function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('[data-agc-submit]');
        if (!btn) return;
        btn.setAttribute('data-loading', 'true');
        var label = btn.querySelector('span');
        if (label) label.textContent = btn.getAttribute('data-sending') || 'Sending…';
      });
    });

    /* After a successful send, bring the confirmation into view + focus it */
    var ok = document.querySelector('[data-agc-success]');
    if (ok) {
      try { ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      ok.focus({ preventScroll: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
